export function toAbsoluteUrl(relative: string): string {
  if (/^https?:\/\//i.test(relative)) {
    return relative;
  }
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}${relative.startsWith("/") ? relative : `/${relative}`}`;
}
